module.exports = __webpack_public_path__ + "img/fadesk-logo-white.51ff6f69.svg";